{
  "collapse": "Pienennä",
  "expand": "Laajenna"
}
